<template>
  <div class="cxhome" style="height: 100%">
    <el-container>
      <div class="header">
        <div class="logo-new">
          <div style="width: 1200px;margin: auto;color: #fff;height: 165px">
<!--            <img src="../../assets/img/bulogo.png" height="52" width="60" style="margin-top: 22px;margin-right:20px;float: left"/>-->
<!--            <div style="padding:20px 0px 10px 20px;font-size: 12px;letter-spacing: 15px; ">工业和信息化部政务服务平台</div>-->
<!--            <div style="letter-spacing: 19px;-->
<!--    font-size: 25px;-->
<!--    font-weight: 600;font-family: 微软雅黑">中小企业诚信服务平台</div>-->
<!--            <img src="../../assets/img/headbanner.png"  style="margin-top: 40px;margin-left:70px;float: left"/>-->
          </div>

      <div class="top_nav" style="position:absolute;right: 60px;top: 1px;">
<!--          <ul v-if="sso !== true">-->
<!--            <router-link to='/enterpriselogin' tag="li"  style="float: left;margin-right:10px;" ><el-button type="primary">企业登录</el-button></router-link>-->
<!--            <router-link to='/mechanismlogin' tag="li" style="float: left;"   ><el-button type="primary">机构登录</el-button></router-link>-->
<!--          </ul>-->
<!--          <ul v-if="sso === true">-->
<!--            <li @click="tosso()"   style="float: left;margin-right:10px;" ><el-button type="primary">企业登录</el-button></li>-->
<!--            <li @click="toMechanismSso()" style="float: left;"   ><el-button type="primary">机构登录</el-button></li>-->
<!--          </ul>-->
        </div>
<!--        <h2>-->
<!--            <a href="http://sme.miit.gov.cn/chengxin/"></a>-->
<!--        </h2>-->
    </div><!--div class="release"><img src="https://www.sme.com.cn/cms/resource/8a8900c96a48cf51016a4c70e1e80136//style/images/head_banner.gif" width="900" height="90"/></div-->
</div>
      <div id="nav-bar">
    <div class="nav-bar">
         <ul class='nav'>
      <li><a href='/' class='active'>首页</a></li>
<!--      <li>-->
<!--       <a href='/xydt' class='active'>信用动态</a>-->
<!--      </li>-->
<!--      <li>-->
<!--       <a href='https://sme.miit.gov.cn/zcfg/index.html' class='active'>政策法规</a>-->
<!--      </li>-->
               <li>
       <a  href='/xydt' class='active'>信用动态</a>
      </li>
      <li>
       <a  href='/static/creditSearchAll.html' class='active'>信用查询</a>
      </li>
                 <li>
       <a  href='/static/rzcx.html' class='active'>认证查询</a>
      </li>
      <li>
       <a href='/static/zzcx.html' class='active'>资质查询</a>
      </li>
      <li>
       <a href='/cxlm' class='active'>诚信联盟</a>
      </li>
<!--      <li>-->
<!--       <a href='/static/zzcx.html' class='active'>双碳行动</a>-->
<!--      </li>-->
       <li>
       <a href='/jdfw' class='active'>监管服务</a>
      </li>
<!--      <li>-->
<!--       <a href='/sxcj' class='active'>失信惩戒</a>-->
<!--      </li>-->
<!--      <li>-->
<!--       <a href='https://sme.miit.gov.cn/cxpd/xyfw/index.html' class='active'>信用服务</a>-->
<!--      </li>-->
<!--      <li>-->
<!--       <a href='https://sme.miit.gov.cn/cxpd/cxft/index.html' class='active'>诚信访谈</a>-->
<!--      </li>-->
    </ul>
<!--        <ul class="nav">-->
<!--          <router-link to='/' tag="li"><a>首页</a></router-link>-->
<!--            <li>-->
<!--                <a href="https://sme.miit.gov.cn/cxpd/xydt/index.html" target="_blank" title="信用动态" _href="https://sme.miit.gov.cn/cxpd/xydt/index.html" textvalue="信用动态">信用动态</a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="https://sme.miit.gov.cn/zcfg/index.html" target="_blank" title="政策法规" _href="https://sme.miit.gov.cn/zcfg/index.html" textvalue="政策法规">政策法规</a>-->
<!--            </li>-->
<!--          <router-link to='/creditsearch' tag="li"><a>公示查询</a></router-link>-->
<!--          <router-link to='/evaluation' tag="li" style="display: none"><a>评价申请</a></router-link>-->
<!--            <li>-->
<!--                <a href="https://sme.miit.gov.cn/cxpd/xyfw/art/2020/art_595693d6f389483397ecd1c524ee9e2c.html" title="信用服务" target="_blank">信用服务</a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="https://sme.miit.gov.cn/cxpd/cxft/index.html" target="_blank" title="诚信访谈" _href="https://sme.miit.gov.cn/cxpd/cxft/index.html" textvalue="诚信访谈">诚信访谈</a>-->
<!--            </li>-->
<!--        </ul>-->
        <div class="clearfix"></div>
    </div>
</div>
      <el-main><router-view/></el-main>

      <el-footer style="height: 169px;
    background-color: #404042;"><!--版权开始-->
<div class="tab_c6">
<!--    <div class="tab_c6_lx" style="background-color: #404042;color: #888">-->
<!--        <a title="关于我们" href="https://sme.miit.gov.cn/dbxxl/gywm/art/2020/art_6a086ede7c2042188479403750f87e88.html" target="_blank" _href="https://sme.miit.gov.cn/dbxxl/gywm/art/2020/art_6a086ede7c2042188479403750f87e88.html" textvalue="关于我们">关于我们</a>  |   <a title="联系我们" href="https://sme.miit.gov.cn/dbxxl/jszc/art/2020/art_76c8407abf354cac89ead97e7ff96fdb.html" target="_blank" _href="https://sme.miit.gov.cn/dbxxl/jszc/art/2020/art_76c8407abf354cac89ead97e7ff96fdb.html">联系我们</a>  |   <a href="https://sme.miit.gov.cn/dbxxl/bwzp/art/2021/art_af03d46acd12432a82f6a45baa96ae91.html">本网招聘</a> |   <a title="特别声明" href="https://sme.miit.gov.cn/dbxxl/yqlj/art/2020/art_70bee699478d4bb185160a49fa63936f.html" target="_blank" _href="https://sme.miit.gov.cn/dbxxl/yqlj/art/2020/art_70bee699478d4bb185160a49fa63936f.html">特别声明</a>-->
<!--    </div>-->
    <div class="tab_c6_foot" style="text-align: left;margin: 40px auto;
    width: 620px;">
<!--      <div style="float: left">-->
<!--      <img src="../../assets/img/jiucuo.png" height="55" width="110"/>-->
<!--        <a target="_blank" href="http://bszs.conac.cn/sitename?method=show&id=072863338FF66940E053022819ACCE02">-->
<!--        <img src="../../assets/img/dzjj.png" height="80" width="80"/></a>-->
<!--      </div>-->
      <div>
        <div class="zddw">
              <div><a href="https://www.sme.com.cn/cms/news/100000/0000000347/95a2f6a09cec4be387e054167d001b04.shtml" target="_blank">关于我们</a>
                丨<a href="https://www.sme.com.cn/cms/news/100000/0000000348/387259f925334f68ad4ad4b8d8f19b9f.shtml" target="_blank">技术支持</a>
                丨<a href="https://www.sme.com.cn/cms/news/100000/0000000350/bc44901d71de4504aa4ed8d5abb6e8a2.shtml" target="_blank">本网招聘</a>
                丨<a href="https://www.sme.com.cn/cms/news/100000/0000000351/70bee699478d4bb185160a49fa63936f.shtml" target="_blank">特别声明</a></div>
            </div>
        <div class="zddw">京ICP备17022951号-2    <span style="margin-left:10px "><img src="../assets/img/jh.png" height="22" width="20"/>京公网安备 11040102700068号</span></div>
        <div class="zddw">联系方式：010-68575152 13810303299</div>
      </div>
    </div>
</div><!--版权结束--></el-footer>
    </el-container>
  </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataPost } from '@/api/index'
export default {
  name: 'headandfoot',
  data () {
    return {
      sso: false}
  },
  created () {
    var that = this
    that.sso = rootPathssb.sso
    console.log(that.sso)
  }, // 页面加载时
  methods: {
    tosso () {
      var that = this
      if (rootPathssb.sso) {
        dataPost(rootPathssb.rootPath + '/us/signin').then(function (response) {
          console.log(that.$route.query.cssSsoTicket)
        })
      }
    },
    toMechanismSso () {
      var that = this
      console.log(11111)
      if (rootPathssb.sso) {
        dataPost(rootPathssb.rootPath + '/j/signin').then(function (response) {
          console.log(that.$route.query.cssSsoTicket)
        })
      }
    }
  }
}
</script>

<style scoped>
  body{
    font-family: "微软雅黑", SimSun, Arial, Arial Narrow, helvetica, clean, serif, sans-serif;
  }
  a{
    font-family: "微软雅黑", SimSun, Arial, Arial Narrow, helvetica, clean, serif, sans-serif
  }
 .el-header, .el-footer {
    color: #333;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    /*background-color: #f5f5f5;*/
    color: #333;
    width: 100%;
    margin: 0 auto;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .header {
    width: 100%;
    /*height: 150px;*/
}
  .header .logo-new {
    width: 100%;
    height: 0px;
    /*background: url(../assets/img/headbanner.png) no-repeat center center;*/
    /*background-position-y:-54px;*/
}
  #nav-bar {
    background: #008cff;}
  .nav-bar {
    margin: 0px auto 0px;
    width: 1200px;
}
  .nav-bar ul {
        padding: 10px 0 10px 5px;
    height: 35px;
    font-size: 18px;
    color: #fff;
    list-style-type: none;
    width: 1200px;
    margin: auto;
}
   .top_nav a{
      text-decoration:none;
   }
  .top_nav ul li{
     list-style-type: none;

  }
 .nav-bar ul li {
    display: inline-block;
    float: left;
    padding: 0 35px;
    line-height: 35px;
    font-size: 18px;
    text-align: center;
   list-style-type: none;
}
  .nav-bar a {
    color: #fff;
    text-decoration: none;
}
  .tab_c6 {
    width: 1200px;
    height: 120px;
    margin: 10px auto 0;
    text-align: center;
}
  .tab_c6_lx {
    background-color: #ddd;
    font-size: 14px;
    color: #000;
    line-height: 35px;
}

.tab_c6_lx  a {
    color: #9e9ea0;
    text-decoration: none;
}
  .tab_c6_foot {
    font-size: 14px;
    color: #9e9ea0;
    line-height: 28px;
}
  .tab_c6_foot ul {
    float: left;
    width: 930px;
    margin-left: 200px;
    list-style: none;
}
  .tab_c6_foot li {
    width: 930px;
    text-align: center;
    float: left;
    color: #333;
    font-size: 14px;
    line-height: 28px;
}
  .tab_c6_foot li h4 {
    margin-right: 20px;
    text-align: center;
    float: left;
    line-height: 28px;
    font-weight: normal;
}
 .zddw{
   color: #fff;
   text-align: center;
 }
  .zddw a{
   color: #fff;
   text-decoration:none
 }
  .lxfs{
    margin-right: 50px;
    width: 200px;
  }
  .jz{
        width: 1000px;
    margin: auto;
  }
.jz a{
  text-decoration: none!important;
    cursor: pointer;
  color: #9e9ea0;
}
</style>
r



// WEBPACK FOOTER //
// src/components/homeNoHeadFoot.vue